import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';

import {
    setModoTela,
    initForm
} from './analisePrecoActions';

let AnalisePrecoForm = props => {

    const formulario =
        props.formularioValues || {};

    const readOnly = props.excluir
        ? 'readOnly'
        : '';

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe'
                            cols='12 8 8 8'
                            readOnly={readOnly}
                        />

                        <Field
                            name='preco'
                            component={LabelAndInputNumber}
                            label='Preço'
                            placeholder='Informe'
                            cols='12 4 4 4'
                            casas={2}
                            readOnly={readOnly}
                        />
                    </Row>
                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')
                                }
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

AnalisePrecoForm = reduxForm({
    form: 'analisePrecoForm',
    destroyOnUnmount: false
})(AnalisePrecoForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues:
        getFormValues('analisePrecoForm')(state),
    registro: state.analisePreco.registro
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnalisePrecoForm);